import * as OvationsApi from 'core/ovations-api';

import {
    cascadingDropdownQuestion,
    dateTimeQuestion,
    dropdownQuestion,
    fileUploadQuestion,
    numberQuestion,
    referredIndividualNameQuestion,
    textQuestion,
} from './question';

export const mockPortalPromotionQuestion: OvationsApi.Types.PortalPromotionQuestion = {
    id: '0',
    question: textQuestion,
    readOnlyOnPortal: true,
    requiredOnPortal: true,
    isForPreFund: false,
    displayOnPortalHistory: false,
};

export const mockNumberPortalPromotionQuestion: OvationsApi.Types.PortalPromotionQuestion = {
    id: '1',
    question: numberQuestion,
    readOnlyOnPortal: true,
    requiredOnPortal: true,
    isForPreFund: false,
    displayOnPortalHistory: false,
};

export const mockDropdownPortalPromotionQuestion: OvationsApi.Types.PortalPromotionQuestion = {
    id: '2',
    question: dropdownQuestion,
    readOnlyOnPortal: true,
    requiredOnPortal: true,
    isForPreFund: false,
    displayOnPortalHistory: false,
};

export const mockCascadingDropdownPortalPromotionQuestion: OvationsApi.Types.PortalPromotionQuestion = {
    id: '3',
    question: cascadingDropdownQuestion,
    readOnlyOnPortal: true,
    requiredOnPortal: true,
    isForPreFund: false,
    displayOnPortalHistory: false,
};

export const mockDatetimePortalPromotionQuestion: OvationsApi.Types.PortalPromotionQuestion = {
    id: '4',
    question: dateTimeQuestion,
    readOnlyOnPortal: true,
    requiredOnPortal: true,
    isForPreFund: false,
    displayOnPortalHistory: false,
};

export const mockFileUploadPortalPromotionQuestion: OvationsApi.Types.PortalPromotionQuestion = {
    id: '5',
    question: fileUploadQuestion,
    readOnlyOnPortal: true,
    requiredOnPortal: true,
    isForPreFund: false,
    displayOnPortalHistory: false,
};

export const mockReferredIndividualNamePromotionQuestion: OvationsApi.Types.PortalPromotionQuestion = {
    id: '6',
    question: referredIndividualNameQuestion,
    readOnlyOnPortal: true,
    requiredOnPortal: true,
    isForPreFund: false,
    displayOnPortalHistory: false,
};

export default mockPortalPromotionQuestion;
